import { render, staticRenderFns } from "./BaseFacilityDisplay.vue?vue&type=template&id=0d6aabdc&scoped=true"
import script from "./BaseFacilityDisplay.vue?vue&type=script&lang=js"
export * from "./BaseFacilityDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6aabdc",
  null
  
)

export default component.exports